import React, { useCallback } from 'react';

import { useXomicsAuth } from './AuthContext';
import { loadCommerceSettings, loadProducts } from './api';
import ProductCoupons from './ProductCoupons';
import { Failed, Loading } from './parts';
import { useLiveResource } from './useLive';
import { tx } from './i18n';

export default function XomicsCoupons() {
  const { permissions } = useXomicsAuth();
  const products = useLiveResource(['products'], useCallback(() => loadProducts(), []));
  const settings = useLiveResource(
    ['products'], useCallback(() => loadCommerceSettings(), []),
  );
  if ((products.loading && products.data === null)
      || (settings.loading && settings.data === null)) {
    return <Loading label={tx('ui.products.coupons.loading')} />;
  }
  if (products.error) return <Failed message={products.error} onRetry={products.refresh} />;
  if (settings.error) return <Failed message={settings.error} onRetry={settings.refresh} />;
  return <div className="xo-platform-page xo-coupons-page">
    <ProductCoupons products={products.data || []}
      categories={settings.data?.categories || []}
      currencies={settings.data?.currencies || []}
      mayManage={permissions.includes('PRODUCT_MANAGE')} />
  </div>;
}
